// extracted by css-extract-rspack-plugin
export default {"wrapper":"dropContainer_wrapper__Hle3r"};